module.exports = __webpack_public_path__ + "931ac1f1b13297f83c1b55d60cd758d3.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/catherine-meade.jpg
// module id = 436
// module chunks = 0